import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '搜索', to: '/search' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 py-12 md:px-8 lg:px-10 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">日韩中文字幕</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              专注日韩影视作品的中文字幕资料整理与信息分享，收录电影、电视剧与综艺作品，帮助中文观众更方便地查找、浏览与了解字幕资源。
            </p>
            <p className="mt-4 max-w-md text-xs leading-relaxed text-background-300">
              本站为字幕信息展示平台，不提供影视文件与字幕文件下载，所有内容仅用于学习交流。
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold text-background-50">站点导航</h2>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold text-background-50">联系方式</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                contact@rihansubtitles.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                字幕更新：每日 10:00 / 20:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-group-line text-accent-400"></i>
                字幕组合作欢迎来函
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 日韩中文字幕 · 保留所有权利</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>演示站点 · 仅供学习交流</span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-shield-check-line"></i>
              内容均为信息展示，不提供下载
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}